import styled from '@emotion/styled';
import { Footer } from '@mds/mds-reactjs-library';

const MCK_BLUE = '#2251ff';

export const StyledFooter = styled(Footer)`
    /* ============================================
       Footer Container Styles
       ============================================ */
    &.mds-medium-footer {
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
        padding: 20px 112px !important;
    }

    /* ============================================
       Height Overrides
       ============================================ */
    &.mds-medium-footer,
    &.mds-medium-footer > * {
        height: auto !important;
        min-height: 0 !important;
    }

    /* ============================================
       Layout & Spacing
       ============================================ */
    /* Right side container: links and copyright */
    &.mds-medium-footer > div:last-of-type {
        display: flex !important;
        flex-direction: column !important;
        gap: 1rem !important;
    }

    /* Links row — center Contact us; drop separator under the link row */
    &.mds-medium-footer > div:last-of-type > div:first-of-type {
        border-bottom: none !important;
        margin-bottom: 10px !important;
        padding-bottom: 0 !important;
        justify-content: center !important;
    }

    &.mds-medium-footer .mds-footer-text-links {
        justify-content: center !important;
    }

    &.mds-medium-footer .mds-footer-text-link:not(.ggc-footer-contact),
    &.mds-medium-footer .mds-footer-text-link:not(.ggc-footer-contact):link,
    &.mds-medium-footer .mds-footer-text-link:not(.ggc-footer-contact):visited {
        font-size: 1.125rem !important;
        font-family: 'McKinsey Sans', sans-serif !important;
    }

    /* ============================================
       Logo Container
       ============================================ */
    &.mds-medium-footer > div:first-of-type {
        margin: 0 !important;
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
    }

    /* All elements inside logo container */
    &.mds-medium-footer > div:first-of-type * {
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
    }

    /* Logo images, SVGs, and links */
    &.mds-medium-footer > div:first-of-type img,
    &.mds-medium-footer > div:first-of-type svg,
    &.mds-medium-footer > div:first-of-type a {
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
    }

    /* Default text links (not Contact us box) */
    &.mds-medium-footer a:not(.ggc-footer-contact),
    &.mds-medium-footer button {
        font-weight: 600 !important;
        box-sizing: border-box !important;
        line-height: 1.5 !important;
        border-bottom: 1px solid transparent !important;
        transition: border-color 0.2s ease !important;

        &:hover {
            border-bottom-color: currentColor !important;
            text-decoration: none !important;
        }
    }

    /* Contact us — dotcom mdc-c-button secondary + size-large (outline box + icon + label) */
    &.mds-medium-footer a.mds-footer-text-link.ggc-footer-contact {
        height: auto !important;
        max-height: none !important;
        min-height: var(--mdc-size-spacing-48, 48px) !important;
        overflow: visible !important;
        box-sizing: border-box !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 10px !important;
        padding: var(--mdc-size-spacing-8, 8px) var(--mdc-size-spacing-24, 24px) !important;
        margin: 4px 0 !important;
        font-family: 'McKinsey Sans', sans-serif !important;
        font-size: var(--mdc-size-font-18, 1.125rem) !important;
        line-height: var(--mdc-size-line-height-28, 1.75rem) !important;
        font-weight: 600 !important;
        color: ${MCK_BLUE} !important;
        text-decoration: none !important;
        background: transparent !important;
        border: 1px solid ${MCK_BLUE} !important;
        border-radius: 0 !important;
        transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease !important;

        @media (prefers-reduced-motion: reduce) {
            transition: none !important;
        }

        &:hover {
            background: ${MCK_BLUE} !important;
            color: #fff !important;
            border-color: ${MCK_BLUE} !important;
            border-bottom: 1px solid ${MCK_BLUE} !important;
            text-decoration: none !important;
        }

        &:focus {
            outline: none !important;
        }

        &:focus-visible {
            outline: 2px solid ${MCK_BLUE} !important;
            outline-offset: 3px !important;
        }

        &:focus-visible:not(:hover) {
            background: transparent !important;
            color: ${MCK_BLUE} !important;
            border-bottom: 1px solid ${MCK_BLUE} !important;
        }
    }

    &.mds-medium-footer a.mds-footer-text-link.ggc-footer-contact .mdc-c-icon.mck-email-icon {
        flex-shrink: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        line-height: inherit;
        font-size: 1.125em;
        color: inherit;
    }

    &.mds-medium-footer a.mds-footer-text-link.ggc-footer-contact .mdc-c-link__label {
        line-height: inherit;
    }
`;
